import { useEffect } from "react";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import Homepage from "./Pages/Homepage";
import Chatpage from "./Pages/Chatpage";
import socket from "./socket";
import { ChatState } from "./Context/ChatProvider";
import OutgoingCallPage from "./Pages/OutgoingCallPage";
import IncomingCallPage from "./Pages/IncomingCallPage";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = ChatState();

  // 👤 Mark user active/inactive for presence
  useEffect(() => {
    if (!user?._id || !socket.connected) return;

    let timeoutId;

    const markInactive = () => {
      socket.emit("user inactive", user._id);
    };

    const resetTimer = () => {
      clearTimeout(timeoutId);
      socket.emit("user active", user._id);
      timeoutId = setTimeout(markInactive, 10 * 60 * 1000); // 10 minutes
    };

    const activityEvents = ["mousemove", "keydown", "scroll", "touchstart"];
    activityEvents.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        resetTimer();
      }
    });

    resetTimer(); // initial trigger

    return () => {
      activityEvents.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
      document.removeEventListener("visibilitychange", resetTimer);
      clearTimeout(timeoutId);
    };
  }, [user, location]);

  // 🔔 Handle Incoming Call Event
  useEffect(() => {
    if (!user?._id || !socket.connected) return;

    const handleIncomingCall = ({ from, signal }) => {
      console.log("📞 Incoming call from:", from);

      // Save caller info in localStorage or global state
      localStorage.setItem("incomingCall", JSON.stringify({ from, signal }));

      // Navigate to the incoming call page
      navigate("/incoming-call");
    };

    socket.on("call:incoming", ({ from, signal, callerInfo }) => {
      localStorage.setItem(
        "incomingCall",
        JSON.stringify({ signal, callerInfo })
      );
      // Optional: redirect to incoming UI if not already there
      window.location.href = "/incoming-call";
    });

    return () => {
      socket.off("call:incoming", handleIncomingCall);
    };
  }, [user, navigate]);

  // 🚦 Define all your routes
  const routes = useRoutes([
    { path: "/", element: <Homepage /> },
    { path: "/chats", element: <Chatpage /> },
    { path: "/outgoing/:calleeId", element: <OutgoingCallPage /> },
    { path: "/incoming-call", element: <IncomingCallPage /> },
  ]);

  return routes;
}

export default App;
